<template>
    <div class="ukl-pull-refresh"
         :style="style"
         @touchstart="touchstart($event)"
         @touchmove="touchmove($event)"
         @touchend="touchend($event)"
    >
        <div class="weui-pull-refreshing-box" :style="boxStyle">
            <div v-if="moveState < 2">            
                <van-icon name="down" class="op-icon" :class="{'up': moveState !== 0}" />
                <span class="loading-text">{{ moveState === 0 ? $t('common.pull_refresh') : $t('common.release_refresh') }}</span>
            </div>
            <div v-else-if="moveState === 2">
                <van-loading type="spinner" class="loading-icon" />
                <!--<img src="../assets/imgs/icn_loading.svg" class="refreshing-icon">--> 
                <span class="loading-text">{{ $t('common.refresh_loading') }}</span>
            </div>
        </div>
        <div class="ukl-pull-refresh-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import { Loading } from 'vant'

    export default {
        name: 'UKL-PULL-REFRESH',
        props: {
            boxStyle: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        components: {
            [Loading.name]: Loading
        },        
        data() {
            return {
                startY: '', //保存touch时的Y坐标
                moveDistance: 0, //保存向下滑动的距离
                moveState: 0, //开始滑动到结束后状态的变化 0:下拉即可刷新 1:释放即可刷新 2:加载中
                duration: 0  //动画持续时间，0就是没有动画
            }
        },
        computed: {
            style () {
                return {
                    transition: `${this.duration}ms`,
                    transform: `translate3d(0,${this.moveDistance/36}rem, 0)`
                }
            }
        },
        methods: {
            touchstart(e) {
                if(this.disabled) return false; // 如果禁用则不处理
                // 正在刷新时不触发
                if(this.moveState === 2) return false;

                this.duration = 0 // 关闭动画
                this.moveDistance = 0 // 滑动距离归0
                this.startY = e.targetTouches[0].clientY  // 获得开始Y坐标
            },
            touchmove(e) {
                if(this.disabled) return false; // 如果禁用则不处理
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
                //首先判断我们有没有滚动条，如果有，我们下拉刷新就不能启用。
                if (scrollTop > 0) return

                let move = e.targetTouches[0].clientY - this.startY
                //判断手指滑动的距离，只有为正数才代表用户下拉了。
                if (move > 0) {
                    //阻止默认事件，在微信浏览器中尤为有用，至于为什么，你去试就知道了。
                    e.preventDefault()
                    //增加滑动阻力的感觉
                    this.moveDistance = Math.pow(move, 0.8)
                    if (this.moveDistance > 60) {
                        //如果滑动距离大于60 那我就告诉你，释放即可刷新
                        if (this.moveState === 1) return
                        this.moveState = 1
                    } else {
                        //否则 恢复原样
                        if (this.moveState === 0) return
                        this.moveState = 0
                    }
                }
            },
            touchend(e) {
                if(this.disabled) return false; // 如果禁用则不处理
                // 正在刷新时不触发
                if(this.moveState === 2) return;

                // 只要手指拿开，我都需要加上结束时的动画，这里为100ms
                this.duration = 100
                if (this.moveDistance > 60) {
                    //这里逻辑跟touchMove一样，但是需要真的加载数据了，那moveState变为2 所以加载动画在这出现
                    this.moveState = 2
                    //因为还没加载完，我得让加载动画显示着，所以这里移动距离为60
                    this.moveDistance = 60
                    this.$emit('refresh', () => {
                        //这里就是成功后的回调了，如果该函数被调用，那就以为着加载数据完成，所以状态要回到0，当然需要在父组件调用。
                        this.moveState = 0
                    })
                } else {
                    //否则 给我老老实实恢复原样
                    this.moveDistance = 0
                }
            }
        },
        watch: {
            //这里是给用户操作返回的核心
            moveState (state) {
                //我们监听moveState的状态，
                //0意味着开始也意味着结束，这里是结束，并且只有动画生效我们才能 moveDistance 设为0，
                //为什么动画生效才行，因为动画生效意味着手指离开了屏幕，如果不懂去看touchEnd方法，这时
                //我们让距离变为0才会有动画效果。
                if (state === 0 && this.duration === 100) {
                    this.moveState = 10; // 随便设置一个大于2的值结束loading
                    setTimeout(() => {
                        this.moveDistance = 0;
                    }, 500);
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .ukl-pull-refresh {
        min-height: calc(100vh + 60px);
        margin-top: -60px;
        .weui-pull-refreshing-box {
            line-height: 60px;
            height: 60px;
            font-size: 14px;
            color: #333;
            text-align: center;
            .x-icon {
                vertical-align:middle;fill:gray;
                margin-right: -5px;
            }
            .refreshing-icon {
                width: 15px;
                vertical-align: middle;
                margin-right: 5px;
                animation: loadC 1.1s infinite linear;
            }
            .op-icon {
                display: inline-block;
                font-size: 20px;
                vertical-align: middle;
                margin-right: 10px;
                &.up {
                    transform: rotate(180deg);
                }
            }
            .loading-icon {
                display: inline-block;
                width: 20px;
                height: 20px;
                line-height: 20px;
                margin-right: 10px;
                color: #333;
                vertical-align: middle;
            }
            .loading-text {
                vertical-align: middle;
            }
        }
        .ukl-pull-refresh-content {
            min-height: calc(100vh - 48px);
        }
    }

    @keyframes loadC {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>